import { Card } from 'react-bootstrap';

const cardDark = { background: 'linear-gradient(135deg, #0d0d0d 0%, #1a0033 100%)', color: '#fff', border: '1px solid #9933ff44' };

const UserIcon = ({ color, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-3.9 3.6-7 8-7s8 3.1 8 7" />
  </svg>
);

const nodeBox = {
  width: 56,
  height: 56,
  borderRadius: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const YouBox = () => (
  <div style={{ ...nodeBox, background: '#00e5ff22', border: '2px solid #00e5ff' }}>
    <UserIcon color="#00e5ff" size={24} />
  </div>
);

export const SlotBox = ({ node }) => {
  const filled = !!node;
  return (
    <div style={{
      ...nodeBox,
      border: `2px dashed ${filled ? '#66ff99' : '#444'}`,
      background: filled ? '#00331a55' : '#0d0d0d55',
    }}>
      <UserIcon color={filled ? '#66ff99' : '#444'} size={24} />
    </div>
  );
};

const CycleIcon = ({ color }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

export const ActiveNodeCard = ({ node, planName, bottomStats }) => (
  <Card style={{ ...cardDark, marginBottom: 16 }}>
    <Card.Body className="p-3">
      {planName && (
        <div style={{ color: '#fff', fontWeight: 700, fontSize: 14, marginBottom: 12, textAlign: 'center' }}>
          {planName}
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, marginBottom: 12 }}>
        <YouBox />
        <div style={{ width: 120, height: 16 }}>
          <svg width="120" height="16" style={{ overflow: 'visible' }}>
            <line x1="60" y1="0" x2="20" y2="16" stroke="#9933ff66" strokeWidth="1.5" />
            <line x1="60" y1="0" x2="100" y2="16" stroke="#9933ff66" strokeWidth="1.5" />
          </svg>
        </div>
        <div style={{ display: 'flex', gap: 16 }}>
          <SlotBox node={node.leftChildId} />
          <SlotBox node={node.rightChildId} />
        </div>
      </div>

      {bottomStats}
    </Card.Body>
  </Card>
);
